export const DELAY_TO_DISPLAY_SLIDEDOWN = 3000;
export const DELAY_TO_HIDE_SLIDEDOWN = 300;
